module.exports = __webpack_public_path__ + "img/11.0f0bd9f6.webp";